export const TOOL_STATUS_ID = {
  AVAILABLE: 1,
  BUY_BACK: 2,
  SOLD: 3,
  LOST: 4,
  DONATED: 5,
  DAMAGED: 6,
  DESTROYED: 7,
  OUTBOUND: 8,
};

export type TToolStatusId = (typeof TOOL_STATUS_ID)[keyof typeof TOOL_STATUS_ID];

export interface IToolStatusUI {
  title: string;
  description: string;
}

export const TOOL_STATUS_UI_BY_ID: Readonly<
  Record<TToolStatusId, IToolStatusUI>
> = {
  [TOOL_STATUS_ID.AVAILABLE]: {
    title: "Disponible",
    description: "Activo y listo para mover o asignar",
  },
  [TOOL_STATUS_ID.BUY_BACK]: {
    title: "Buy Back",
    description: "Comprada al cliente y agregada a stock propio para reventa",
  },
  [TOOL_STATUS_ID.SOLD]: {
    title: "Vendida a tercero",
    description: "Ya no pertenece a la organización/cliente",
  },
  [TOOL_STATUS_ID.LOST]: {
    title: "Perdida",
    description: "No localizada físicamente y declarada como perdida",
  },
  [TOOL_STATUS_ID.DONATED]: {
    title: "Donada",
    description: "Entregada sin fines comerciales.",
  },
  [TOOL_STATUS_ID.DAMAGED]: {
    title: "Dañada",
    description: "Irrecuperable para uso o venta",
  },
  [TOOL_STATUS_ID.DESTROYED]: {
    title: "Destruida",
    description: "Eliminada por desmantelamiento, sin recuperación posible",
  },
  [TOOL_STATUS_ID.OUTBOUND]: {
    title: "Salida outbound",
    description: "Retirada de inventario sin causa o motivo registrado",
  },
};
